var _excluded = ["children", "disabled", "size", "readOnly", "variant", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { MDLink, LGLink } from './StyledLink';
var sizes = {
  md: MDLink,
  lg: LGLink
};
var AgroLink = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    disabled = _ref.disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    readOnly = _ref.readOnly,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var SizeLink = sizes[size];
  var handleClick = function handleClick(e) {
    setTimeout(function () {
      if (onClick) {
        onClick(e);
      }
    }, 0);
  };
  return readOnly ? /*#__PURE__*/React.createElement(SizeLink, _extends({
    as: "span",
    disabled: disabled,
    variant: variant,
    linkRef: forwardedRef,
    onClick: function onClick(e) {
      return handleClick(e);
    }
  }, props), children) : /*#__PURE__*/React.createElement(SizeLink, _extends({
    disabled: disabled,
    variant: variant,
    linkRef: forwardedRef,
    onClick: function onClick(e) {
      return handleClick(e);
    }
  }, props), children);
});
AgroLink.propTypes = {
  children: PropTypes.node,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  linkRef: PropTypes.any,
  size: PropTypes.oneOf(['md', 'lg']),
  variant: PropTypes.oneOf(['primary', 'danger', 'darkMode'])
};
AgroLink.displayName = 'AgroLink';
export { AgroLink };